<div class="top-left-counter-card">
  <div *ngIf="linkCounter.projectstd" class="counterItem">
    <span class="linkCount">{{ linkCounter.projectstd | number }}</span>
    <span class="linkLabel" *ngIf="linkCounter.projectstd == 1">{{ 'projectValuation.project' | translate | uppercase }}</span>
    <span class="linkLabel" *ngIf="linkCounter.projectstd != 1">{{ 'projectValuation.projects' | translate | uppercase }}</span>
  </div>
  <div *ngIf="linkCounter.valuationPortfolio" class="counterItem">
    <span class="linkCount">{{ linkCounter.valuationPortfolio | number }}</span>
    <span class="linkLabel" *ngIf="linkCounter.valuationPortfolio == 1">{{ 'projectValuation.valuationPortfolio' | translate | uppercase }}</span>
    <span class="linkLabel" *ngIf="linkCounter.valuationPortfolio != 1">{{ 'projectValuation.valuationPortfolios' | translate | uppercase }}</span>
  </div>
  <div *ngIf="linkCounter.reports" class="counterItem">
    <span class="linkCount">{{ linkCounter.reports | number }}</span>
    <span class="linkLabel" *ngIf="linkCounter.reports == 1">{{ 'projectValuation.report' | translate | uppercase }}</span>
    <span class="linkLabel" *ngIf="linkCounter.reports != 1">{{ 'projectValuation.reports' | translate | uppercase }}</span>
  </div>
  <div *ngIf="linkCounter.property" class="counterItem">
    <span class="linkCount">{{ linkCounter.property | number }}</span>
    <span class="linkLabel" *ngIf="linkCounter.property == 1">{{ 'projectValuation.property' | translate | uppercase }}</span>
    <span class="linkLabel" *ngIf="linkCounter.property != 1">{{ 'projectValuation.properties' | translate | uppercase }}</span>
  </div>
  <div *ngIf="linkCounter.portfolioRam" class="counterItem">
    <span class="linkCount">{{ linkCounter.portfolioRam | number }}</span>
    <span class="linkLabel" *ngIf="linkCounter.portfolioRam == 1">{{ 'projectValuation.mandate' | translate | uppercase }}</span>
    <span class="linkLabel" *ngIf="linkCounter.portfolioRam != 1">{{ 'projectValuation.mandates' | translate | uppercase }}</span>
  </div>
</div>
